module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card import-company"
  }, [_c('input', {
    ref: "csvImport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function () { return _vm.handleFile('pick'); }
    }
  }), _vm._v(" "), _c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Add Company\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.results.length) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    on: {
      "click": _vm.saveImported
    }
  }, [_vm._v("\n      Save\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.loadingCSV,
      "disabled": _vm.loadingCSV
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_vm._v("\n      Import CSV\n    ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dismissible": ""
    },
    model: {
      value: (_vm.alert.status),
      callback: function($$v) {
        _vm.$set(_vm.alert, "status", $$v)
      },
      expression: "alert.status"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.alert.message) + "\n  ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.results.length) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.results,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companylegalname || 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companydescription || 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.emailaddress || 'N/A'))])]
      }
    }], null, false, 2879541083)
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f674af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Company/ImportCompany.vue
// module id = 1695
// module chunks = 7